export default __webpack_public_path__ + "static/media/logo_parlamentia.29ac9485.svg";